import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments/UploadFileWithPreviewFormData';
import { type EventApplicationModuleEmailContentsSetting } from '../../../../api/types';

export enum HeaderTabs {
    Vehicles = 'vehicles',
    EmailContents = 'emailContents',
    ModuleDetails = 'moduleDetails',
}

export enum EditMode {
    Vehicles = 'vehicles',
    FinanceProducts = 'financeProducts',
    ModuleDetails = 'moduleDetails',
}

export const FOOTER_ID = 'eventApplicationModuleFooterLayout';

export type EventApplicationModuleEmailFormValues = {
    submitOrder: EventApplicationModuleEmailContentsSetting['submitOrder'] & {
        introImage?: File | UploadFileWithPreviewFormDataFragment;
    };
};

export type EventApplicationModuleCounterKey =
    | 'leadCounter'
    | 'applicationCounter'
    | 'reservationCounter'
    | 'appointmentCounter'
    | 'eventCounter';
